import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useData } from '../../Context/DataContext';
import PageHeader from '../../components/PageHeader/PageHeader';
import FilterTabs from '../../components/FilterTabs/FilterTabs';
import Button from '../../components/Button/Button';
import styles from './Verification.module.css';

const Verification = () => {
  const [activeTab, setActiveTab] = useState('all');
  const { verificationItems } = useData();

  const flaggedCount = verificationItems.filter((item) => item.isFlagged).length;

  const tabs = [
    { id: 'all', label: 'To review', count: verificationItems.length },
    { id: 'flagged', label: 'Flagged by auto-check', count: flaggedCount },
    { id: 'approved', label: 'Approved today', count: 118 }
  ];

  const filteredList = verificationItems.filter((item) => {
    if (activeTab === 'flagged') return item.isFlagged;
    if (activeTab === 'approved') return !item.isFlagged;
    return true;
  });

  const headerActions = (
    <>
      <Link to="/settings">
        <Button variant="secondary">Auto-check rules</Button>
      </Link>
      <Link to="/doc-review">
        <Button variant="primary">Start reviewing</Button>
      </Link>
    </>
  );

  return (
    <>
      <PageHeader
        title="Verification queue"
        subtitle="Proof participants uploaded for study eligibility."
        actions={headerActions}
      />

      <FilterTabs
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      />

      <section className={styles.tableCard}>
        <div className={styles.tableHeader}>
          <div>Participant</div>
          <div>Study</div>
          <div>Document</div>
          <div>Uploaded</div>
          <div>Auto-check</div>
          <div></div>
        </div>

        {filteredList.map((item) => (
          <div key={item.id} className={styles.tableRow}>
            <div>
              <span className={styles.participantName}>{item.participant}</span>
            </div>
            <div className={styles.studyText}>{item.study}</div>
            <div className={styles.documentText}>{item.document}</div>
            <div className={styles.uploadedText}>{item.uploaded}</div>
            <div>
              <span
                className={styles.badge}
                style={{ color: item.result.color, background: item.result.bg }}
              >
                {item.result.label}
              </span>
            </div>
            <div>
              <Link to="/doc-review" className={styles.reviewLink}>
                Review →
              </Link>
            </div>
          </div>
        ))}
      </section>
    </>
  );
};

export default Verification;
